import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function MainLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const showBreadcrumb = location.pathname !== "/";

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      {showBreadcrumb && (
        <div className="pt-16 md:pt-20">
          <Breadcrumb />
        </div>
      )}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}